/* RESPONSIBLE TEAM: team-workflows */
import type SetTicketState from 'embercom/models/operator/visual-builder/step/set-ticket-state';
import StepConfig, { type StepConfigParams } from '../step';

export default class SetTicketStateConfiguration extends StepConfig {
  declare step: SetTicketState;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/set-ticket-state',
      ...params,
    });
  }
}
